<div class="w-full py-3 px-4">
  <!-- Stock Title Section -->
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-6"><mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style="mask-type: alpha;"><rect width="24" height="24" fill="#C19725"></rect></mask><g mask="url(#mask0_848_1764)"><path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path></g></svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Stock" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Raw Metal List</span> -->
    </div>
     <div>
        <a routerLink="/raw-metal/metal"
          class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
          Add New Raw Metal
        </a>
      </div>
  </div>
  <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-1 sm:gap-2">
    <div class="flex items-center justify-center md:justify-start gap-1 sm:gap-2">
      <!-- Search -->
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Rows :
        </label>
        <select id="rowFilter" [(ngModel)]="visibleRowCount" (change)="updateVisibleRows()"
          class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725">
          <option *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]" [value]="count">
            {{ count }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none">
          <svg width="10" height="5" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Search :
        </label>
        <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725" autocomplete="off"/>
      </div>
    </div>

    <div class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2">
      <!-- Download Buttons -->
      <button class="text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()">
        Download PDF
      </button>
      <button class="text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()">
        Download Excel
      </button>
      <button class="text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()">
        Download All JSON
      </button>
      <button class="text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()">
        Download CSV
      </button>

      <div class="relative inline-block text-left">
        <button (click)="toggleDropdown()" class="text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
          Column Visibility
        </button>

        <div *ngIf="showDropdown" class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64">
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <!-- Checkbox list -->
          <label *ngFor="let field of selectedFields" class="block text-sm mb-1">
            <input type="checkbox" [(ngModel)]="field.selected" autocomplete="off"/>
            {{ field.label }}
          </label>

          <!-- Button actions -->
          <div class="mt-3 flex flex-col gap-2">
            <button (click)="selectAllFields()" class="text-sm text-blue-600 hover:underline text-left">
              Select All
            </button>
            <button (click)="deselectAllFields()" class="text-sm text-red-800 hover:underline text-left">
              Deselect All
            </button>
            <button (click)="restoreColumnSelection()" class="text-sm text-gray-600 hover:underline text-left">
              Restore Columns
            </button>

            <!-- Apply button -->
            <button (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] transition">
              Apply
            </button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
        Print
      </button>
    </div>
  </div>

  <!-- feature list desktop layout -->
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table
      class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            No.
          </th>
          <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0">
            <div class="flex flex-col gap-1 w-32">
              <!-- Search Input -->
              <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full" [autofocus]="field.key === 'st_code'" autocomplete="off"/>

              <!-- Sortable Label -->
              <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                  <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                  <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let item of paginatedStockList; let i = index">
          <!-- Serial Number -->
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <!-- Dynamic Fields -->
          <ng-container *ngFor="let field of selectedFields">
            <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">
              {{ item[field.key] }}
            </td>
          </ng-container>

        <!-- Action Buttons -->
        <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
          <div class="flex items-center justify-center gap-1 sm:gap-2">
            <!-- View/Edit Button -->
            <button class="cursor-pointer" routerLink="/edit/{{item.st_id}}/raw-metal">
              <svg
                class="w-4 h-4 sm:w-5 sm:h-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                  stroke="#C19725"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.7166 9.23962L8.10638 15.8499"
                  stroke="#C19725"
                  stroke-miterlimit="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

              <!-- Delete Button -->
              <button class="cursor-pointer p-1" (click)="deleteMetal(item.st_id)">
                <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <div
        class="flex items-center justify-end border-t border-gray-200 bg-white py-3"
      >
        <div class="flex sm:flex-1 sm:items-center sm:justify-end">
          <div>
            <nav
              class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs"
              aria-label="Pagination"
            >
              <button
                (click)="goToPreviousPage()"
                [disabled]="currentPage === 1"
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
              >
                <span class="sr-only">Previous</span>
                <svg
                  class="size-6"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <button
                (click)="goToPage(1)"
                [class.bg-c19725]="currentPage === 1"
                [class.text-white]="currentPage === 1"
                class="relative z-10 inline-flex items-center justify-center bg-c19725 w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ext-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725"
              >
                1
              </button>
              <button
                (click)="goToPage(2)"
                [class.bg-c19725]="currentPage === 2"
                [class.text-white]="currentPage === 2"
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
              >
                2
              </button>
              <span
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
                >...</span
              >
              <button
                (click)="goToPage(10)"
                [class.bg-c19725]="currentPage === 10"
                [class.text-white]="currentPage === 10"
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
              >
                10
              </button>
              <button
                (click)="goToNextPage()"
                [disabled]="currentPage === totalPages"
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
              >
                <span class="sr-only">Next</span>
                <svg
                  class="size-6"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </nav>
          </div>
        </div>
      </div>
</div>
